if (typeof Lineas !== " function") {
  window.Lineas = function (wrapper, duracion, formato, data) {
    let boxYPaddingLeft = formato == "horizontal" ? 160 : 160;

    let box = new Box({
      size: { width: 1600, height: 3200 },
      padding: { left: 20, top: 50, right: 50, bottom: 20 },
    });

    let boxY = new Box({
      size: { width: 0, height: box.content.height - 20 },
      padding: { left: boxYPaddingLeft, top: 20 },
    });

    let boxX = new Box({
      size: {
        width: box.content.width - (boxY.exterior.width + 50),
        height: 0,
      },
      margin: { left: boxY.exterior.width + 50 },
    });

    let boxMain = new Box({
      size: {
        width: boxX.content.width,
        height: box.content.height - 40,
      },
      margin: { left: boxY.exterior.width, top: 20 },
    });

    let svg = null;
    let gEjeXAnios = null;
    let gEjeX = null;
    let gEjeY = null;
    let gMain = null;
    let gLeyenda = null;

    let svgLeyenda = null;
    let gEtiquetas = null;

    const escalaX = d3
      .scaleTime()
      .domain([new Date(2025, 0, 1), new Date(2026, 0, 31)])
      .range([0, boxX.content.width]);

    const formatoFecha = d3.timeFormat("%b");
    const formatoFechaAnios = d3.timeFormat("%Y");
    const formatoFechaTooltip = d3.timeFormat("%d de %B de %Y");

    const escalaY = d3
      .scaleOrdinal()
      .domain(
        _.map(
          [
            "Aguascalientes",
            "Baja California",
            "Baja California Sur",
            "Campeche",
            "Chiapas",
            "Chihuahua",
            "Ciudad de México",
            "Coahuila de Zaragoza",
            "Colima",
            "Durango",
            "Guanajuato",
            "Guerrero",
            "Hidalgo",
            "Jalisco",
            "México",
            "Michoacán de Ocampo",
            "Morelos",
            "Nayarit",
            "Nuevo León",
            "Oaxaca",
            "Puebla",
            "Querétaro",
            "Quintana Roo",
            "San Luis Potosí",
            "Sinaloa",
            "Sonora",
            "Tabasco",
            "Tamaulipas",
            "Tlaxcala",
            "Veracruz de Ignacio de la Llave",
            "Yucatán",
            "Zacatecas",
          ],
          (d) => d.toUpperCase(),
        ),
      );

    const escalaYEtiqueta = d3
      .scaleOrdinal()
      .domain([
        "AGS",
        "BCN",
        "BCS",
        "CAMP",
        "CAMP",
        "CHP",
        "CHIH",
        "CMX",
        "COAH",
        "COL",
        "DGO",
        "GTO",
        "GRO",
        "HGO",
        "JAL",
        "MEX",
        "MICH",
        "MOR",
        "NAY",
        "NLE",
        "OAX",
        "PUE",
        "QRO",
        "Q. ROO",
        "SLP",
        "SIN",
        "SON",
        "TAB",
        "TAMPS",
        "TLAX",
        "VER",
        "YUC",
        "ZAC",
      ]);

    const color = d3.scaleLinear().range(["#edf1ff", "#ff0000"]);

    let escalaRadio = d3.scaleSqrt().domain([0, 30]).range([0, 30]);

    function setup() {
      crearSVG(wrapper);
      crearScatterPlot();
      crearLeyenda();
    }

    function crearSVG(wrapper) {
      let y = 0;
      let range = [];
      _.each(escalaY.domain(), function (d, i) {
        let offset = boxY.content.height / escalaY.domain().length;
        range.push(i * offset);
      });
      escalaY.range(range);
      escalaYEtiqueta.range(range);

      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height + 200}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`,
        );

      gEjeXAnios = svg
        .append("g")
        .style("stroke", "#a3a3a3")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .style("font-size", "60px")
        .attr("data-g", "gEjeXAnios")
        .attr(
          "transform",
          `translate(${boxX.margin.left}, ${boxX.padding.top + 190})`,
        )
        .call(
          d3
            .axisTop(escalaX)
            .tickSize(0)
            .tickFormat(formatoFechaAnios)
            .tickValues([new Date(2025, 0, 15), new Date(2026, 0, 15)]),
        );

      gEjeX = svg
        .append("g")
        .style("stroke", "#a3a3a3")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .style("font-size", "60px")
        .attr("data-g", "gEjeX")
        .attr(
          "transform",
          `translate(${boxX.margin.left}, ${boxX.padding.top + 220})`,
        )
        .call(
          d3
            .axisTop(escalaX)
            .tickSize(0)
            .tickFormat(formatoFecha)
            .tickValues([
              new Date(2025, 0, 15),
              new Date(2025, 3, 15),
              new Date(2025, 6, 15),
              new Date(2025, 9, 15),
              new Date(2026, 0, 15),
            ]),
        );

      gEjeY = svg
        .append("g")
        .style("stroke", "#a3a3a3")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .attr("data-g", "gEjeY")
        .attr(
          "transform",
          `translate(${boxY.padding.left}, ${boxY.padding.top + 220})`,
        )
        .call(d3.axisLeft(escalaYEtiqueta).tickSize(0));

      gMain = svg
        .append("g")
        .style("stroke", "#a3a3a3")
        .style("stroke-width", 0.5)
        .style("fill", "transparent")
        .attr("data-g", "gMain")
        .attr(
          "transform",
          `translate(${boxMain.margin.left}, ${boxMain.margin.top + 220})`,
        );

      gLeyenda = svg
        .append("g")
        .style("stroke", "#a3a3a3")
        .style("stroke-width", 1)
        .attr("data-g", "gLeyenda")
        .attr("transform", `translate(${boxMain.margin.left}, -40)`);
    }

    function crearLeyenda() {
      let arreglo = [1, 5, 10, 50, 100];
      let espacioFuerte = 20;
      let espacioDebil = 5;
      let x = 0;

      let g = gLeyenda.append("g");

      let t = g
        .append("text")
        .text("Contagios por día:")
        .attr("x", x)
        .attr("y", 100)
        .attr("dominant-baseline", "middle");
      let caja = t.node().getBBox();
      x += caja.width;
      x += espacioFuerte;

      _.each(arreglo, function (a) {
        let r = escalaRadio(a);
        x += r;
        g.append("circle")
          .attr("r", r)
          .attr("cx", x)
          .attr("cy", 100)
          .style("fill", "#f57a7aff")
          .style("stroke", "#202020ff")
          .style("fill-opacity", 0.3);
        x += r;
        x += espacioDebil;
        t = g
          .append("text")
          .text(a)
          .attr("x", x)
          .attr("y", 100)
          .attr("dominant-baseline", "middle");
        caja = t.node().getBBox();
        x += caja.width;
        x += espacioFuerte;
      });

      caja = g.node().getBBox();
      g.attr(
        "transform",
        `translate(${boxX.content.width / 2 - caja.width / 2}, 0)`,
      );
    }

    function crearScatterPlot() {
      let obj = {};
      _.each(data, function (d) {
        let fecha = d.fecha_diagnostico;
        let entidad = d.entidad_nombre_res;
        let clave = `${entidad}|${fecha}`;
        if (!obj.hasOwnProperty(clave)) {
          obj[clave] = {
            fecha_diagnostico: d.fecha_diagnostico,
            entidad_nombre_res: d.entidad_nombre_res,
            total: 0,
          };
        }
        obj[clave].total = obj[clave].total + 1;
      });

      let arreglo = _.values(obj);
      arreglo.sort(function (a, b) {
        return b.total - a.total;
      });

      let estados = escalaY.domain();
      gMain
        .selectAll("line.estado")
        .data(estados)
        .enter()
        .append("line")
        .attr("class", "estado")
        .attr("x1", 20)
        .attr("x2", boxMain.content.width)
        .attr("y1", escalaY)
        .attr("y2", escalaY);

      gMain
        .append("line")
        .attr("stroke-dasharray", "10 10")
        .attr("stroke", "#4b4b4b")
        .attr("stroke-width", "2px")
        .attr("x1", escalaX(new Date(2026, 0, 1)))
        .attr("x2", escalaX(new Date(2026, 0, 1)))
        .attr("y1", 0 - 50)
        .attr("y2", boxMain.content.height - 50);

      gMain
        .selectAll("circle.contagio")
        .data(arreglo)
        .enter()
        .append("circle")
        .attr("class", "contagio")
        .attr("cx", function (d) {
          return escalaX(new Date(d.fecha_diagnostico));
        })
        .attr("cy", function (d) {
          return escalaY(d.entidad_nombre_res);
        })
        .attr("r", (d) => escalaRadio(d.total))
        .style("fill", "#f57a7aff")
        .style("stroke", "#202020ff")
        .style("fill-opacity", 0.3)
        .on("mouseover", crearTooltip)
        .on("mouseout", deshacerTooltip);
    }

    function crearTooltip(e, d) {
      let x = escalaX(new Date(d.fecha_diagnostico));
      let y = escalaY(d.entidad_nombre_res);
      let r = escalaRadio(d.total);

      let el = d3.select(this);

      let gTooltip = gMain.append("g").attr("class", "tooltip ignore");

      let rect = gTooltip
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 0)
        .attr("height", 0)
        .style("fill", "#ffffff")
        .style("stroke", "gray")
        .style("stroke-width", "2px");

      let text = gTooltip
        .append("text")
        .attr("x", 0)
        .attr("y", 0)
        .attr("dy", 0)
        .attr("text-anchor", "middle");

      text.append("tspan").style("font-weight", 700).text(`${d.total}`);
      text
        .append("tspan")
        .text(
          ` contagios diagnosticados el ${formatoFechaTooltip(
            new Date(d.fecha_diagnostico),
          )}`,
        );

      let caja = text.node().getBBox();

      y -= r + 30;
      y = y <= 0 ? 20 : y;

      rect
        .attr("x", caja.x - 10)
        .attr("y", caja.y - 10)
        .attr("width", caja.width + 20)
        .attr("height", caja.height + 20);

      let overflow = x + (caja.x - 10) + (caja.width + 20);
      let underflow = x - (caja.x - 10 + (caja.width + 20));
      let width = caja.width + 20;

      if (overflow > boxMain.content.width) {
        gTooltip.attr(
          "transform",
          `translate(${boxMain.content.width - width / 2}, ${y})`,
        );
      } else if (underflow < 0) {
        gTooltip.attr("transform", `translate(${0 + width / 2}, ${y})`);
      } else {
        gTooltip.attr("transform", `translate(${x}, ${y})`);
      }
    }

    function deshacerTooltip(e, d) {
      gMain.selectAll("g.tooltip").remove();
    }
    setup();
  };
}
